import localforage from "localforage";

export const _onboarding = localforage.createInstance({
  name: "ONBOARDING",
});
